import { defineAsyncComponent } from 'vue'

import OActionBar from '@/components/elements/ActionBar.vue'
// Lazy: drags in radar-sdk-js + maplibre-gl (~760KB). See .docs/performance.md.
const OAddress = defineAsyncComponent(() => import('@/components/elements/Address.vue'))
import OAlert from '@/components/elements/Alert.vue'
import OAnnotate from '@/components/elements/annotate/index.vue'
import OAvatar from '@/components/elements/Avatar.vue'
import OBreadcrumbs from '@/components/elements/Breadcrumbs.vue'
import OButton from '@/components/elements/Button.vue'
import OButtonGroup from '@/components/elements/ButtonGroup.vue'
import OHeading from '@/components/elements/Heading.vue'
import OCard from '@/components/elements/Card.vue'
import OChip from '@/components/elements/Chip.vue'
import OCode from '@/components/elements/Code.vue'
import OCollapse from '@/components/elements/Collapse.vue'
import OCustomField from '@/components/elements/CustomField.vue'
import OCustomFields from '@/components/elements/CustomFields.vue'
import ODescriptionDetails from '@/components/elements/DescriptionDetails.vue'
import ODivider from '@/components/elements/Divider.vue'
import ODraggable from '@/components/elements/Draggable.vue'
import ODropdown from '@/components/elements/dropdown/Dropdown.vue'
import ODropdownItem from '@/components/elements/dropdown/DropdownItem.vue'
import ODropdownDivider from '@/components/elements/dropdown/DropdownDivider.vue'
import ODropdownSubmenu from '@/components/elements/dropdown/DropdownSubmenu.vue'
import ODropdownField from '@/components/elements/dropdown/DropdownField.vue'
// import OEditor from '~/components/elements/editor/Editor.vue'
import OError from '@/components/elements/Error.vue'
import OFieldGroup from '@/components/elements/FieldGroup.vue'
import OFilters from '@/components/elements/Filters.vue'
import OForm from '@/components/elements/Form.vue'
import OGroup from '@/components/elements/Group.vue'
import OHistoryLink from '~/components/elements/HistoryLink.vue'
import OIcon from '@/components/elements/Icon.vue'
import OInternalLink from '@/components/elements/InternalLink.vue'
import OLightbox from '@/components/elements/Lightbox.vue'
import OLoader from '@/components/elements/Loader.vue'
import OMenu from '@/components/elements/Menu.vue'
import OMonthPicker from '@/components/elements/MonthPicker.vue'
import OPager from '@/components/elements/Pager.vue'
import OPagination from '@/components/elements/Pagination.vue'
// Lazy: drags in zxcvbn frequency dictionary (~790KB). See .docs/performance.md.
const OPasswordStrength = defineAsyncComponent(() => import('@/components/elements/PasswordStrength.vue'))
import OPaywall from '@/components/elements/Paywall.vue'
import OProgress from '@/components/elements/Progress.vue'
import OScroll from '@/components/elements/Scroll.vue'
import OScrollspy from '@/components/elements/scrollspy/Scrollspy.vue'
import OScrollspySection from '@/components/elements/scrollspy/Section.vue'
import OSidebar from '@/components/elements/Sidebar.vue'
import OStatistic from '@/components/elements/Statistic.vue'
import OSteps from '@/components/elements/steps/Steps.vue'
import OStep from '@/components/elements/steps/Step.vue'
import OEmail from '@/components/elements/Email.vue'
import OSms from '@/components/elements/Sms.vue'
import OTable from '@/components/elements/Table.vue'
import OTabs from '@/components/elements/tabs/Tabs.vue'
import OTab from '@/components/elements/tabs/Tab.vue'
import OTabMenu from '@/components/elements/tabs/TabMenu.vue'
import OTooltip from '@/components/elements/Tooltip.vue'
import OUpload from '@/components/elements/Upload.vue'
import OSkeleton from '@/components/elements/Skeleton.vue'

export {
  OActionBar,
  OAddress,
  OAlert,
  OAnnotate,
  OAvatar,
  OBreadcrumbs,
  OButton,
  OButtonGroup,
  OHeading,
  OCard,
  OChip,
  OCode,
  OCollapse,
  OCustomField,
  OCustomFields,
  ODescriptionDetails,
  ODivider,
  ODraggable,
  ODropdown,
  ODropdownItem,
  ODropdownDivider,
  ODropdownSubmenu,
  ODropdownField,
  // OEditor,
  OError,
  OFieldGroup,
  OFilters,
  OForm,
  OGroup,
  OHistoryLink,
  OIcon,
  OInternalLink,
  OLightbox,
  OLoader,
  OMenu,
  OMonthPicker,
  OPager,
  OPagination,
  OPasswordStrength,
  OPaywall,
  OProgress,
  OScroll,
  OScrollspy,
  OScrollspySection,
  OSidebar,
  OStatistic,
  OSteps,
  OStep,
  OEmail,
  OSms,
  OTabs,
  OTab,
  OTabMenu,
  OTable,
  OTooltip,
  OUpload,
  OSkeleton,
}
